<template>
  <!-- <div class='container' ref="containerBox" @scroll="handleScroll">
    <div ref="stickyBox" :class="[{ sticky: isSticky }, { box: !isSticky }]"
      :style="{ background: isSticky ? '#fff' : 'transparent' }">
      <titlePage :isSticky="isSticky" :scrollToTop="scrollToTop"></titlePage>
    </div>
    <el-main v-if="$route.path == '/home'">
      <homePageVue :scrollToTop="scrollToTop"></homePageVue>
    </el-main>
    <el-main v-else>
      <router-view></router-view>
    </el-main>
    <fotterVue></fotterVue>
  </div> -->
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
import titlePage from '@/components/titlePage.vue';
import fotterVue from '@/components/fotter.vue';
import homePageVue from './homePage.vue';
export default {
  name: 'fotter',
  components: {
    // titlePage,
    // fotterVue,
    // homePageVue,
  },
  data() {
    return {
      isSticky: false,
      stickyBoxTop: 0,
    }
  },
  beforeMount() {
    console.log(this.$route.path, 'this.$route.path');

  },
  mounted() {
    // const stickyBox = this.$refs.stickyBox;
    // this.stickyBoxTop = stickyBox.offsetTop;
    // window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      this.isSticky = scrollTop > this.stickyBoxTop;
    },
    scrollToTop() {
      this.$refs.containerBox.scrollTop = 0;
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  height: 100vh;
  position: relative;
  overflow-y: auto;
}

.tittleBox {
  max-width: 1200px;
  margin: 0 auto;
}

.box {
  width: 100%;
  min-width: 1200px;
  position: absolute;
  top: 0;
  z-index: 99999;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1000;
  min-width: 1200px;
}

.el-main {
  padding: 0;
  min-width: 1200px;
}


.container::-webkit-scrollbar {
  display: none;
}
</style>
